<template>
    <div class="auto-que-item">
        <!--        类别-->
        <span
            class="type"
            :style="{
                color: keyMap[queData.SubjectType].color,
                background: keyMap[queData.SubjectType].background,
            }"
        >
            {{ keyMap[queData.SubjectType].name }}
        </span>
        <question-show
            :data="queData.Content"
            :start="`<span>${queData.qId}、</span>`"
        ></question-show>
        <div v-if="[1, 2].includes(queData.SubjectType)" class="q-option">
            <div
                v-for="(op, oInd) in queData.AnswerList"
                :key="oInd"
                class="xy-center jf-start f-c-868EA1 op"
                :class="[opRepeat(op.Option) ? 'err-op' : 'corr-op']"
            >
                <el-radio
                    v-if="queData.SubjectType === 1"
                    :value="queData.Answer"
                    :label="op.Option"
                    ><span>{{ op.Option }}.</span></el-radio
                >

                <el-checkbox
                    v-if="queData.SubjectType === 2"
                    :value="queData.Answer.includes(op.Option)"
                    ><span>{{ op.Option }}.</span></el-checkbox
                >
                <question-show
                    :data="op.Content"
                    class="que-show"
                ></question-show>
            </div>
        </div>
        <div class="ana-ans-diff xy-start">
            <span v-if="queData.SubjectType !== 3" class="c-868FA7"
                >答案：</span
            >
            <span v-if="queData.SubjectType === 1">{{ queData.Answer }}</span>
            <span v-else-if="queData.SubjectType === 2">{{
                queData.Answer.join("、")
            }}</span>
            <span v-else-if="queData.SubjectType === 4">{{
                queData.Answer === 1 ? "正确" : "错误"
            }}</span>
            <div v-else-if="queData.SubjectType === 3">
                <div
                    v-for="(f, fInd) in queData.Answer"
                    :key="fInd"
                    class="xy-center jf-start"
                >
                    <span class="c-868FA7">答案{{ fInd + 1 }}：</span>
                    <question-show :data="f"></question-show>
                </div>
            </div>
            <question-show
                v-else
                :data="queData.Answer"
                class="que-show"
            ></question-show>
        </div>
        <div
            v-if="queData.Analysis"
            class="analysis ana-ans-diff xy-center jf-start"
        >
            <span class="c-868FA7">解析：</span>
            <question-show
                :data="queData.Analysis"
                class="que-show"
            ></question-show>
        </div>
        <!--            难度-->
        <div class="difficulty ana-ans-diff">
            <span class="c-868FA7">难度：</span
            ><span>{{ queDifficulty(queData.Hardlevel) }}</span>
        </div>
        <div
            class="r-check"
            :class="[
                AnswerCheck === '答案不能为空'
                    ? 'b-c-red c-fff'
                    : 'c-red no-padding',
            ]"
        >
            {{ AnswerCheck }}
        </div>
        <div
            class="r-check"
            :class="[
                rightOptionCheck === '请输入选项（至少两项）'
                    ? 'b-c-red c-fff'
                    : 'c-red no-padding',
            ]"
        >
            {{ rightOptionCheck }}
        </div>
    </div>
</template>

<script>
import QuestionShow from "./QuestionShow.vue";
import { isEmpty } from "lodash";
export default {
    components: { QuestionShow },
    props: {
        queData: {
            type: Object,
        },
    },
    data() {
        return {
            keyMap: {
                1: {
                    name: "单选题",
                    color: "#ff9197",
                    background: "rgba(255,143,148,0.2)",
                },
                2: {
                    name: "多选题",
                    color: "#408AF2",
                    background: "rgba(64,138,242,0.2)",
                },
                3: {
                    name: "填空题",
                    color: "#5ac325",
                    background: "rgba(90, 195, 37,0.2)",
                },
                4: {
                    name: "判断题",
                    color: "#a45ae6",
                    background: "rgba(164,90,230,0.2)",
                },
                5: {
                    name: "简答题",
                    color: "#FFBF00",
                    background: "rgba(255, 191,0,0.2)",
                },
            },
        };
    },
    computed: {
        AnswerCheck() {
            let msg;
            let qItem = this.queData;
            if (!qItem.Answer && qItem.Answer !== 0) {
                msg = "答案不能为空";
            } else if (qItem.SubjectType === 1) {
                if (qItem.Answer.length > 1) {
                    msg = "单选题答案只能唯一";
                } else if (qItem.AnswerList && qItem.AnswerList.length >= 1) {
                    const isRight = qItem.AnswerList.some((op) => {
                        return op.Option === qItem.Answer;
                    });
                    msg = isRight ? "" : "答案与选项不匹配";
                }
            } else if (qItem.SubjectType === 2) {
                if (qItem.Answer.length < 2) {
                    return "多选题答案至少两个";
                } else if (qItem.AnswerList && qItem.AnswerList.length >= 2) {
                    const isRight = qItem.Answer.every((ans) => {
                        const arr = qItem.AnswerList.map((v) => v.Option);
                        return arr.includes(ans);
                    });
                    msg = isRight ? "" : "答案与选项不匹配";
                }
            } else if (qItem.SubjectType === 3) {
                const blankNumber =
                    qItem.Content.split(/[)）_]/).filter((v) => v).length - 1;
                if (blankNumber !== qItem.Answer.length) {
                    msg = "填空数与答案数不匹配";
                }
            }
            return msg;
        },
        rightOptionCheck() {
            let msg;
            let qItem = this.queData;
            if ([1, 2].includes(qItem.SubjectType)) {
                if (
                    !qItem.AnswerList ||
                    (qItem.AnswerList && qItem.AnswerList.length < 2)
                ) {
                    msg = "请输入选项（至少两项）";
                } else {
                    const ansOp = qItem.AnswerList.map((v) => v.Option).sort();
                    for (let i = 1; i < ansOp.length; i++) {
                        if (ansOp[i - 1] === ansOp[i]) {
                            msg = "已输入重复选项";
                        }
                    }
                }
                return msg;
            }
            return "";
        },
        isError() {
            return !isEmpty(this.AnswerCheck) || !isEmpty(this.rightOptionCheck);
        },
    },
    watch: {
        queData() {
            this.setChecked()
        },
        AnswerCheck(newValue, oldValue) {
            this.setChecked()
        }
    },
    mounted() {
        this.setChecked()
    },
    methods: {
        // 设置试题是否检查通过
        setChecked() {
            let isPass = !this.isError;
            this.$set(this.queData, "_checked", isPass)
        },
        opRepeat(op) {
            const ansOp = this.queData.AnswerList.map((v) => v.Option);
            console.log(ansOp.filter((i) => i === op).length > 1);
            return ansOp.filter((i) => i === op).length > 1;
        },
        queDifficulty(level) {
            // console.log("level:", level);
            if (level === 1) {
                return "简单";
            } else if (level === 2) {
                return "普通";
            } else {
                return "困难";
            }
        },
    },
};
</script>

<style lang="less" scoped>
.auto-que-item {
    .type {
        margin-bottom: 10px;
        padding: 3px 7px;
        border-radius: 3px;
        display: inline-block;
    }
    .q-option {
        .op {
            padding: 5px 20px;
            border-radius: 3px;
            margin-bottom: 5px;

            label {
                margin-right: 11px;
            }
        }

        .corr-op {
            border: none;
        }

        .err-op {
            border: 1px solid red;
        }
    }
    .ana-ans-diff {
        margin-top: 10px;
    }
    .r-check {
        padding: 5px 10px;
        margin-top: 10px;
    }

    .no-padding {
        padding: 0;
    }
}
.err-que-box {
    border: 1px solid var(--f-c-root);
}
</style>
